import 'css-chunksrc/client/pages/zonePage/navigation/styles.scss';export default {
  "navigation": "_navigation_x1p6u_1",
  "item": "_item_x1p6u_8",
  "icon": "_icon_x1p6u_14",
  "selectedItem": "_selectedItem_x1p6u_18",
  "selectedLink": "_selectedLink_x1p6u_24",
  "text": "_text_x1p6u_36",
  "link": "_link_x1p6u_43"
};